import axios, { AxiosResponse } from 'axios';
import { useMemo } from 'react';

import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { RecentNewsArticleModel } from '../apiSchema';

async function getFeaturedNewsArticles(): Promise<RecentNewsArticleModel[]> {
    const response: AxiosResponse<RecentNewsArticleModel[]> = await axios.get(getApiLink('NewsArticle/GetFeaturedNewsArticles'));

    return response.data;
}

export default function useFeaturedNewsArticles() {
    const { data: featuredNewsArticles, isLoading: isFeaturedNewsArticlesLoading } = useData<RecentNewsArticleModel[]>(
        [],
        getFeaturedNewsArticles
    );

    const featuredArticleIds = useMemo(() => {
        if (!featuredNewsArticles) return [];
        const ids = featuredNewsArticles.map((a) => a.id).filter((id): id is number => typeof id === 'number');
        return Array.from(new Set(ids));
    }, [featuredNewsArticles]);

    return {
        featuredNewsArticles,
        isFeaturedNewsArticlesLoading,
        featuredArticleIds
    };
}
